// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-namibia/calculator-namibia-vaf/calculator-namibia-vaf.component.scss
// module id = 695
// module chunks = 0